import Loading from './modules/loading.js';
import SmoothScroll from './modules/smoothscroll.js';
import Common from './modules/common.js';

class App {
	constructor() {
    this.pageElem = document.querySelector("#js-main");
    if(this.pageElem) {
      this.page = this.pageElem.dataset.page;
    }
		this.routes();
  }

	routes() {
    this.loading = new Loading();
        // アニメーションが再生済みならスキップ
        if (sessionStorage.getItem('loadingPlayed')) {
          this.loading._showContentImmediately();
          this.smoothScroll = new SmoothScroll();
          this.common = new Common(this.smoothScroll);
        } else {
          // フラグを立てる
          sessionStorage.setItem('loadingPlayed', 'true');
          this.loading.init();
          this.smoothScroll = new SmoothScroll();
          this.common = new Common(this.smoothScroll);
        }

	}
}

window.App = new App();